import 'bootstrap/dist/css/bootstrap.min.css';
import {   FaWindowClose } from "react-icons/fa";
import { useEffect, useRef, useState } from 'react';
import { Author, Card, ContainerFather, Dots, Footer, Header, Input, InputGroup, MessageBubble, MessageRow, Messages, SendButton, Time, Typing} from './ChatManagerStyles';
import { useDispatch, useSelector } from 'react-redux'
import { saveChat } from '../../redux/chatManager/chatManagerActions';
import { usersListAction } from '../../redux/userList/userListAction';
import { userChatIdAction,  userDeleteByIdAction} from '../../redux/userChatId/userChatIdAction';

function ChatManager({socket, id}) {
  
  
  useEffect(() => {
    
    const key = window.prompt('password');
    if (key !== 'chichester') {
      window.location.reload();
      
      return
    }
  }, []);


  const handlePurga = () => {
  if (window.confirm('¿Are you shure to delete this conversation?')) {
    dispatch(userDeleteByIdAction(id))
    }
  }


  const dispatch = useDispatch();

  const messagesEndRef = useRef(null);
  
  const [typing, setTyping] = useState(false);
  
  const [currentMessage, setCurrentMessage] = useState('');

 
  
  const [messages, setMessages] = useState([]);

  

  
  
  const  usersMessage = useSelector(state=>state.userChatId.users);

  
  
 
  






 

  

  useEffect(() => {
  

    socket.emit('join_room', id);
    console.log(
      `socket ${localStorage.getItem('userId')} joined room ${id}`
    );

    socket.on('receive_message', (data) => {
      console.log(data.room)
      setMessages((prev) => [...prev, data]);


      dispatch(userChatIdAction( {
         id: id,
         messages:[ data]
      }))
    
    });
    
    return () => {
      socket.off('receive_message');
     
    };
  }, [socket, id]);
  
  useEffect(() => {
  
  socket.on('user_list', (data) => {   
    dispatch(usersListAction(data));  
    
    
  });
}, [socket]);











  
  

  useEffect(() => {
  messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
}, [usersMessage]);

  /* ============== SEND MESSAGE ============== */


   // Sends

  const sendMessage = () => {
   


 




    if (currentMessage.trim() === '') return;

    const messageData = {
      room: id,
      author: localStorage.getItem('userId'),
      message: currentMessage,
      time:
        new Date().getHours() +
        ':' +
        String(new Date().getMinutes()).padStart(2, '0'),
    };

    socket.emit('send_message', messageData);
    setMessages((prev) => [...prev, messageData]);
    setCurrentMessage('');
    
   dispatch(userChatIdAction( {
    id: id,
    messages:[ messageData]
   }))
    
    
  };


  //typing
  

let typingTimeout;

const handleChange = (e) => {
  //setMessage(e.target.value);

   setCurrentMessage(e.target.value)

 
  
  socket.emit("typing", id);

  clearTimeout(typingTimeout);

  typingTimeout = setTimeout(() => {
    socket.emit("stopTyping", id);
  }, 2000);
};

  useEffect(() => {
  socket.on("typing", () => {
    setTyping(true);
  });

  socket.on("stopTyping", () => {
    setTyping(false);
  });

  return () => {
    socket.off("typing");
    socket.off("stopTyping");
  };
}, []);

  
  /* ================= RENDER ================= */

  return (
    <>

 <ContainerFather style={{marginTop: '30px'}}>
    

  <div style={{padding: '10px'}}>

 
  <Card>
   
    <Header>
      
      <div style={{marginRight:'10px'}}>
      {id == localStorage.getItem('userId') ? 'Chat' : id}
      </div>
      <div>
        <FaWindowClose fontSize={'20px'} cursor={'pointer'} onClick={handlePurga}/>
      </div>
    </Header>

    <Messages>
      {usersMessage.length > 0 && usersMessage.find(v => v.id === id)?.messages?.map((msg, index) => {
        const isMine = msg.author === localStorage.getItem("userId");
        
        return (
          <MessageRow key={index} isMine={isMine}>
            <MessageBubble isMine={isMine}>
              <Author isMine={isMine}>
                {isMine ? "Me" : 'User'}
              </Author>

              {msg.message}

              <Time>{msg.time}</Time>
            </MessageBubble>
          </MessageRow>
        );
      })}



       <div ref={messagesEndRef} />
    </Messages>
     

    <Footer>
         
    {typing && (
  <Typing positionn={'absolute'} topp={'-40%'} rightt={'10%'}>
    <span>writing</span>
    <Dots>
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </Dots>
  </Typing>
)}
      <InputGroup>
        <Input
          type="text"
          placeholder="Escribí un mensaje..."
          value={currentMessage}
          onChange={handleChange}
          onKeyDown={(e) => e.key === "Enter" && sendMessage()}
          />
        <SendButton onClick={sendMessage}>
          Enviar
        </SendButton>
      </InputGroup>
      
    </Footer>
    
  </Card>
 
          
</div>

          </ContainerFather>
          </>
   
  );
}



export default ChatManager